var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQubic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_11847)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1083_11847)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1083_11847)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1083_11847)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1083_11847)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.489 36.5896C110.711 47.6285 113.441 59.0235 114.69 70.769L114.685 70.7633C114.775 71.6224 114.832 72.4759 114.865 73.3294L114.871 73.3354L114.865 73.3411C115.538 89.6875 106.025 104.841 90.9224 111.381L90.9147 111.376C90.8015 111.423 90.6882 111.472 90.5748 111.52C90.2984 111.637 90.0211 111.755 89.7411 111.867C78.6908 116.242 67.5389 119.237 56.2795 120.667C38.2148 122.957 20.9131 112.765 14.1813 95.8425C9.65379 84.4588 6.58459 72.9733 5.18848 61.3692C3.01235 43.2932 13.4917 26.0933 30.4881 19.5592C41.7023 15.2465 53.2782 12.4713 65.2271 11.2277C83.1335 9.36815 100.062 19.774 106.489 36.5896ZM58.4613 89.2406C63.2431 88.6358 67.9797 87.3641 72.6768 85.5045V85.4988C79.7252 82.7122 84.0775 75.5734 83.2748 68.0389C82.7492 63.0479 81.5848 58.2096 79.793 53.5182C77.063 46.3737 69.8733 41.9536 62.2653 42.7449C57.1895 43.2706 52.272 44.4519 47.5072 46.2832C40.2835 49.0642 35.8295 56.3669 36.7565 64.0484C37.35 68.9772 38.6557 73.8551 40.5775 78.6935C43.4375 85.8832 50.7855 90.2128 58.4613 89.2406Z",
    fill: "#004EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.887 78.2473C121.015 76.3312 118.008 74.6977 114.871 73.3354C115.544 89.6875 106.025 104.836 90.928 111.375C91.0467 111.454 91.1654 111.539 91.2898 111.618C95.3594 114.207 99.8191 116.248 104.618 117.813C111.825 120.165 119.726 117.446 123.92 111.132C126.696 106.95 128.894 102.484 130.505 97.7307C132.964 90.4901 130.245 82.4922 123.887 78.2473Z",
    fill: "#00DFBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.871 73.3354C113.368 72.6798 111.836 72.0806 110.264 71.555C102.933 69.0849 94.8394 71.8659 90.6511 78.3716C87.9606 82.543 85.8523 87.1327 84.247 92.0841C81.907 99.3077 84.6483 107.164 90.9224 111.381C106.025 104.841 115.538 89.6875 114.865 73.3411L114.871 73.3354Z",
    fill: "#0042C0"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_11847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.25,
    height: 131.25,
    fill: "white",
    transform: "translate(0.375 0.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1083_11847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.25,
    height: 131.25,
    fill: "white",
    transform: "translate(0.375 0.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1083_11847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146.631,
    height: 146.631,
    fill: "white",
    transform: "translate(-7.31543 -7.31543)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1083_11847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146.631,
    height: 146.631,
    fill: "white",
    transform: "translate(-7.31543 -7.31543)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1083_11847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 439.893,
    height: 109.973,
    fill: "white",
    transform: "translate(4.90381 11.0137)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQubic);
export default __webpack_public_path__ + "static/media/icon-qubic.185ada5d7a97417612c65f305721e404.svg";
export { ForwardRef as ReactComponent };